/**
 * 点击事件埋点
 * @param element 被点击的元素
 * @param track 追踪函数
 */
export function trackClick(element: HTMLElement, track?: (data: any) => void): void {
  const trackingData = element.dataset.tracking;
  if (!trackingData) return;

  try {
    const data = JSON.parse(trackingData);
    if (track) {
      track({
        eventType: 'click',
        eventName: data.eventName || '页面点击',
        params: {
          element: element.tagName.toLowerCase(),
          id: element.id,
          className: element.className,
          textContent: element.textContent?.substring(0, 50),
          ...data.params,
        },
      });
    }
  } catch (e) {
    console.log('解析埋点数据失败:', e);
  }
}

/**
 * 设置点击事件监听
 * @param track 追踪函数
 */
export function setupClickTracking(track?: (data: any) => void): void {
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    trackClick(target, track);
  });
}
